import * as a from "react";
const l = (e) => /* @__PURE__ */ a.createElement(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...e
  },
  /* @__PURE__ */ a.createElement(
    "path",
    {
      d: "M5 1a3 3 0 00-3 3v16a3 3 0 003 3h6a1 1 0 100-2H5a1 1 0 01-1-1V4a1 1 0 011-1h12a1 1 0 011 1v8a1 1 0 102 0V4a3 3 0 00-3-3H5z",
      fill: "#292933"
    }
  ),
  /* @__PURE__ */ a.createElement(
    "path",
    {
      d: "M7 6a1 1 0 000 2h5a1 1 0 100-2H7zM7 10a1 1 0 100 2h8a1 1 0 100-2H7zM7 14a1 1 0 100 2h3a1 1 0 100-2H7z",
      fill: "#292933"
    }
  ),
  /* @__PURE__ */ a.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M17.535 20.609a2.283 2.283 0 01-1.498-1.31h2.7c.442 0 .826-.343.826-.799s-.384-.8-.826-.8h-2.7c.256-.62.8-1.11 1.498-1.309a2.43 2.43 0 012.325.55c.204.22.513.31.804.243a.813.813 0 00.612-.588.785.785 0 00-.26-.795c-1.068-1.008-2.637-1.357-4.059-.908-1.35.426-2.36 1.508-2.649 2.836a.803.803 0 00-.608.771c0 .379.265.68.608.771.288 1.329 1.299 2.41 2.65 2.836 1.424.45 2.998.099 4.065-.915l.008-.008.008-.009a.782.782 0 00-.044-1.097.847.847 0 00-1.11-.041l-.01.007-.008.008a2.43 2.43 0 01-2.332.557zM15.716 17.7z",
      fill: "#292933"
    }
  )
), t = l;
export {
  t as default
};
